module.exports = __webpack_public_path__ + "img/手机收银(1).d256d69f.png";